// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';

import DatePicker from 'react-datepicker';
import moment from 'moment';
import FlatButton from 'material-ui/FlatButton';
import Avatar               from 'material-ui/Avatar';

class ScheduleDemo extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      schedule: {
        id: "",        
        "customer":{
          "name": '',
        },
        "venue_id": "",
        "game_type_id": "",
        "follow_up_date": moment(),
      },
      venues: [],
      game_types: [],
      sessions: '',
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleStartDate = this.handleStartDate.bind(this);
  }


  componentDidMount() {
    this.getFixtureList(); 
    this.getLeadDetails();
    this.customerFulldetails();
  }
  customerFulldetails(){
    const url = `${getLocationOrigin()}/customer_list/get_customer_info/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ profile_list: data.profile_list, profile_data: data.profile_data}))
       .catch(error => error);
  }
  switchProfile(id, props){
    console.log(props);
    const url = `${getLocationOrigin()}/customer_list/get_customer_info/?customer_id=${id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ profile_list: data.profile_list, profile_data: data.profile_data,  id: id}, ()=>{this.getLeadDetails()}))
       .catch(error => error);   
  }
  handleStartDate(date){
    var new_selected_one =  Object.assign({}, this.state.schedule);
    new_selected_one['follow_up_date'] = date
    this.setState({schedule: new_selected_one});
  }
  getFixtureList() {
     const url = `${getLocationOrigin()}/eagleeye/get_details_for_fixture_creation/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ venues: data.venues, game_types: data.game_type}))
       .catch(error => error);
  }
  
  getLeadDetails(){
    const url = `${getLocationOrigin()}/lead/get_last_lead/?customer_id=${this.state.id}`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ schedule: data.lead}))
       .catch(error => error);


  }
  getFixtureDetails(data, props){
    if((this.state.schedule.game_type_id == 8 || this.state.schedule.game_type_id == 10) && this.state.schedule.customer.customer_type != "Child"){
      alert("Please ensure that you are scheduling demo for CHILD!!")
    }
    else{
      console.log(this.state.profile_data.customer_type);
    }

    var date = moment(data.follow_up_date).format("YYYY-MM-DD");
    const url = `${getLocationOrigin()}/fixture_session/demo_allocation_from_lead/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({  'date': date,
                                        'game_type_id': this.state.schedule.game_type_id,
                                       'venue_id': this.state.schedule.venue_id });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then( response =>                     
            this.setState({sessions: response.data})
    )
      .catch(error => {
        console.log(error);
        alert(error.message);
      });


  }


  handleChange(event) {
    const name = event.target.name;
    var new_selected_one = Object.assign({}, this.state.schedule);
    new_selected_one[name] = event.target.value
    console.log('asdddddddddd');
    console.log(new_selected_one);
    this.setState({schedule: new_selected_one});
  }

  handleSubmit(event) {
    event.preventDefault();
   
    this.getFixtureDetails(this.state.schedule, this.props);
    console.log('post');
    console.log(this.state);
  }
  scheduleDemo(sessionid, props){
    console.log(sessionid);
    const url = `${getLocationOrigin()}/add_demo_in_session/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({'customer_id': this.state.id,
                                      'fixture_session_id': sessionid
                                        });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          alert(response.Message);
          props.history.goBack();
      })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }

  render() { 
      console.log(this.state.profile_list);
    return(
      <div style={styles.container}>
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Schedule Demo</h3>
          </div>
          <div className="col-md-12" style={{flexDirection: 'row', justifyContent: 'space-between', border: '1px solid #f2f2f2', }}>
                   <h4 style={{textAlign:'center'}}>Switch Profile</h4>
                  { this.state.profile_list ?
                    this.state.profile_list.map((list, index)=>(
                      <div key={index} style={{display: (list.selected == true) ? 'none': 'flex' , alignSelf: 'center', marginBottom: '4px', flexDirection: 'column', float: 'right'}} className="col-md-2" onClick={()=>{this.switchProfile(list.id, this.props)}}>
          
                        <Avatar size={60} src={list.photo.includes('http') ? list.photo : 'https://api.sporthood.in'+list.photo} style={{alignSelf: 'center'}}/>
                         <span style={{fontSize: '100%', fontWeight: 600, paddingTop: '1%', alignSelf: 'center', }} onClick={()=>{this.switchProfile(list.id, this.props)}}>{list.name}</span>

                      </div>))
                    :
                    <div>
                    </div>
                  }
               <div style={{flexDirection: 'column', }}>   
                <button className="btn" style={{border: 'none', backgroundColor: '#fff', float: 'left', margin: '13px'}}>
                <Link to={`../../crud/childProfile/${this.state.id}`}> <i className="fa fa-plus-circle" style={{fontSize: 'large'}}></i>
                <span style={{fontSize: '100%', fontWeight: 600, margin: '4px'}}>Add Kid profile</span>
                </Link>
                </button>
               </div>                           
          </div>  
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Customer 
              </div>
              <div className="col-md-6 input-group">
                  {this.state.schedule.customer.name}
              </div>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Venue
              </div>
              <select name="venue_id" className="col-md-6" style={styles.item_body} value={this.state.schedule.venue_id}
                onChange={this.handleChange}>
                { this.state.venues ?
                  this.state.venues.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.name}</option>
                  ))
                  :
                  <option>Loading....</option>
                }
              </select>
            </div>
             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game Type
              </div>
              <select name="game_type_id" className="col-md-6" style={styles.item_body} value={this.state.schedule.game_type_id}
                onChange={this.handleChange}>
                { this.state.game_types ? 
                  this.state.game_types.map((x, index) => (
                  <option key={x.pk} value={x.pk}>{x.game + ' ' + x.name}</option>
                  ))
                  :
                  <option>Loading...</option>
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Follow up Date
              </div>
              <DatePicker selected={moment(this.state.schedule.follow_up_date)} onChange={this.handleStartDate}/>
            </div>

            <div style={styles.button_submit} className="col-md-10">
              <input className="btn btn-lg" type="submit" value="Submit" style={{backgroundColor:'#302C35',
                color:'#ffffff', marginLeft: '80px'}}/>
            </div>
    
          </form>
          {
            this.state.sessions ? 
            <div>
            <div style={styles.sub_header} className="col-md-12">
            <h3 style={{textAlign:'center', }}>Fixture Session List</h3>
          </div>
          {
            this.state.sessions.map((session, index)=>(
                <div key={index} style={styles.fixture_list} className="col-md-8">
                <div style={{flexDirection: 'row',}}>
                <h4 style={{textAlign:'center', color: '#FFFFFF'}}>{session.start_time} - {session.end_time}</h4>
                </div>
                <div>
                <span style={{textAlign:'center', fontSize: '14px', color: '#FFFFFF'}}> {session.name}</span>
                </div>
                <span style={{textAlign:'left', fontSize: '15px', color: '#FDD60B'}}> Slots Left: {session.free_slots}</span>
                <div style={styles.button} onClick={()=> this.scheduleDemo(session.id, this.props)}>
                <p style={{textAlign: 'center'}}>Schedule</p>
                </div>        
           </div>
              )

            )
          }
          

          </div>
          :
          <div>
          </div>

          }
          
        </div>

      </div>
    );
  }
}

export default ScheduleDemo;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/scheduleDemo/index.js